import { useGetAriaIngestionKeyQuery } from "@smb/ehr-connector/config-app-graphql";
import { useEffect, useMemo } from "react";

import {
  ContextColumns,
  updateLoggingContext,
  useTelemetryContext,
} from "@smb/web-telemetry";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  EHR_APP_CLIENT_ID,
  EHR_APP_ENV,
  EHR_APP_NAME,
} from "../../../environments/environment";

export const InstrumentationKeyProvider: React.FC<
  React.PropsWithChildren<{
    apolloClient?: ApolloClient<NormalizedCacheObject>;
  }>
> = ({ children, apolloClient: client }) => {
  const { data, error } = useGetAriaIngestionKeyQuery({
    client,
    fetchPolicy: "cache-and-network", // telemetry ingestion key should leverage the cache and always verify response through the network call.
  });

  const { setTelementryIngestionKey } = useTelemetryContext();
  updateLoggingContext(undefined, {
    [ContextColumns.AppInfoEnvironment]: EHR_APP_ENV,
    [ContextColumns.AppId]: EHR_APP_CLIENT_ID,
    [ContextColumns.AppName]: EHR_APP_NAME,
  });

  const instrumentationKey = useMemo(
    () => data?.getAriaIngestionKey ?? undefined,
    [data]
  );

  useEffect(() => {
    setTelementryIngestionKey(instrumentationKey);
  }, [instrumentationKey, setTelementryIngestionKey]);

  useEffect(() => {
    if (error) {
      console.error(`[InstrumentationKeyProvider] Error: ${error}`);
    }
  }, [error]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
